import { render, staticRenderFns } from "./AffiliatesDashboard.vue?vue&type=template&id=5309939f&"
import script from "./AffiliatesDashboard.vue?vue&type=script&lang=js&"
export * from "./AffiliatesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5309939f')) {
      api.createRecord('5309939f', component.options)
    } else {
      api.reload('5309939f', component.options)
    }
    module.hot.accept("./AffiliatesDashboard.vue?vue&type=template&id=5309939f&", function () {
      api.rerender('5309939f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliatesDashboard.vue"
export default component.exports